<template>
  <b-modal
    id="editDirectionGroupModal"
    size="lg"
    :title="title"
    @ok="onSave"
    @show="updateData"
  >
    <b-form-group label="Код">
      <b-form-input
        required
        v-model="formData.code"
        placeholder="110000"
        v-mask="'######'"
      />
    </b-form-group>
    <b-form-group label="Название">
      <b-form-input
        required
        v-model="formData.title"
      />
    </b-form-group>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isDisabled">
        Сохранить
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'EditDirectionGroupModal',
  directives: { mask },
  props: {
    editData: {
      type: Object,
      default: null
    }
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      }
    }
  },
  data() {
    return {
      title: '',
      addTitle: 'Добавление классификатора направления',
      editTitle: 'Редактирование классификатора направления',
      formData: {
        id: null,
        title: '',
        code: ''
      }
    }
  },
  computed: {
    isDisabled() {
      return !(this.formData && this.formData.title
        && this.formData.code && this.formData.code.length === 6)
    }
  },
  methods: {
    updateData() {
      this.formData = this.editData || this.clearData()
      this.title = this.editData ? this.editTitle : this.addTitle
    },
    onSave() {
      this.$emit('save', this.formData)
    },
    clearData() {
      return {
        id: null,
        title: '',
        code: ''
      }
    }
  }
}
</script>

<style scoped>

</style>
